import React from "react";
import { Box, Typography, Grid, Card, CardContent, Avatar, IconButton } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { PlayArrow } from "@mui/icons-material";

export default function BlackFridayBanner() {
  const [isPlaying, setIsPlaying] = React.useState(false);


  return (
    <Box sx={{ width: "100%", py: 5, px: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
      {/* Header */}
      <Box sx={{ textAlign: "center", mb: 4, maxWidth: 1232 }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: 32, md: 54 },
            background: "linear-gradient(to right, #0d8828, #0d799d)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 1,
          }}
        >
          Early Black Friday Deals
        </Typography>
        <Typography
          sx={{ fontSize: { xs: 16, md: 20 }, color: "#000", maxWidth: 900, m: "0 auto" }}
        >
          Limited-Time: <strong>50% Off</strong> Our Top Plans — Plus FREE EasySuite CRM, AI Webinar Builder & Paid Webinars
        </Typography>
      </Box>

      {/* Content */}
      <Grid container spacing={1} justifyContent="center" sx={{ maxWidth: 1400 }}>
        {/* Left Stats */}
        <Grid item xs={12} md={2.5} textAlign="center">
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: 33, fontWeight: 600 }}>200K+</Typography>
            <Typography sx={{ fontSize: 11 }}>Total Webinars Hosted</Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: 33, fontWeight: 600 }}>4.4</Typography>
            <Box sx={{ width: 80, mx: "auto", my: 1 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none">
              <path d="M4.26588 6.23743L1.61374 8.15287L2.65916 5.03765L5.48872e-06 3.1152H3.25554L4.26588 -5.82385e-06L5.27622 3.1152H8.53175L5.8726 5.03765L6.91802 8.15287L4.26588 6.23743ZM14.5982 6.23743L11.946 8.15287L12.9915 5.03765L10.3323 3.1152H13.5878L14.5982 -5.82385e-06L15.6085 3.1152H18.864L16.2049 5.03765L17.2503 8.15287L14.5982 6.23743ZM24.9305 6.23743L22.2783 8.15287L23.3237 5.03765L20.6646 3.1152H23.9201L24.9305 -5.82385e-06L25.9408 3.1152H29.1963L26.5372 5.03765L27.5826 8.15287L24.9305 6.23743ZM35.2627 6.23743L32.6106 8.15287L33.656 5.03765L30.9969 3.1152H34.2524L35.2627 -5.82385e-06L36.2731 3.1152H39.5286L36.8695 5.03765L37.9149 8.15287L35.2627 6.23743ZM45.595 6.23743L42.9429 8.15287L43.9883 5.03765L41.3292 3.1152H44.5847L45.595 -5.82385e-06L46.6054 3.1152H49.8609L47.2018 5.03765L48.2472 8.15287L45.595 6.23743Z" fill="url(#paint0_linear_23074_74672)"></path>
              <defs>
              <linearGradient id="paint0_linear_23074_74672" x1="-0.923813" y1="4.06202" x2="47.4306" y2="3.83657" gradientUnits="userSpaceOnUse">
              <stop offset="0.96" stopColor="#68C5ED"></stop>
              <stop offset="0.96" stopColor="#BDE2F5"></stop>
              </linearGradient>
              </defs>
            </svg>
            </Box>
            <Box>
              <img src="https://easywebinar-site.easywebinar.com/images/capterra-logo.png" alt="capterra" width="90" />
            </Box>
          </Box>

          <Box>
            <img src="https://easywebinar-site.easywebinar.com/images/trusted-clients.png" width="120" />
          </Box>
        </Grid>

        {/* Video */}
        <Grid item xs={12} md={6} className="bf-banner-right" sx={{ position: 'relative' }}>
          {!isPlaying ? (
          <Box className="bf-video-box" sx={{ position: 'relative' }}>
          <img
          src="https://easywebinar-site.easywebinar.com/images/bf-casey-banner.png?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
          alt="Thumbnail"
          className="bf-banner-thumbnail"
          style={{ width: '100%', borderRadius: '20px' }}
          />


          <IconButton
          className="bf-play-btn"
          onClick={() => setIsPlaying(true)}
          sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          width: 70,
          height: 70,
          boxShadow: 3,
          }}
          >
          <PlayArrow sx={{ fontSize: 40 }} />
          </IconButton>
          </Box>
          ) : (
          <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
          <iframe
          src={`https://player.vimeo.com/video/1134186691?h=0aed6f181d&autoplay=1&badge=0&autopause=0&player_id=0&app_id=58479`}
          title="Black Friday Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          frameBorder="0"
          style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0,
          borderRadius: '20px'
          }}
          />
          </Box>
          )}
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={3.5} textAlign="center">
          <Box sx={{ mb: 3 }}>
            <img src="https://easywebinar-site.easywebinar.com/images/gdpr-2-logos.png" width="180" />
          </Box>
          <Box sx={{ mb: 3 }}>
            <img src="https://easywebinar-site.easywebinar.com/images/performer-logos.png" width="180" />
          </Box>

          <Card elevation={0} sx={{ maxWidth: 260, mx: "auto", backgroundColor: 'transparent' }}>
            <CardContent sx={{ padding: '0', backgroundColor: 'transparent' }}>
              <Typography sx={{ fontSize: 14, opacity: 0.9, textAlign: 'left' }}>
                <strong>$5M</strong> generated from one evergreen webinar funnel as Carla scaled from small live events to a fully
                automated system with smart scheduling and seamless integrations.
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2 }}>
                <Avatar
                  src="https://easywebinar-site.easywebinar.com/images/carla-video-img.png"
                  variant="rounded"
                  sx={{ width: 59, height: 43, borderRadius: 2 }}
                />
                <Box textAlign="left">
                  <Typography sx={{ fontSize: 16, fontWeight: 500 }}>Carla Biesinger</Typography>
                  <Typography sx={{ fontSize: 12, opacity: 0.7 }}>Small-Business Owner</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
